import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import WelcomeCustom from '@/views/WelcomeCustom.vue'
// import Tours from '@/views/tours/TourList.vue'
// import TourView from '@/views/tours/TourView.vue'
// import Account from '@/views/Account.vue'
// import Settings from '@/views/Settings.vue'
// import Signout from '@/views/Signout.vue'

import Login from '@/views/auth/Login'
import Register from '@/views/auth/Register'
import RegistrationComplete from '@/views/auth/RegistrationComplete'
import ForgotPassword from '@/views/auth/ForgotPassword'
import NewPassword from '@/views/auth/NewPassword'
import ConfirmEmail from '@/views/auth/ConfirmEmail'
import AcceptInvitation from '@/views/auth/AcceptInvitation'
import Signout from '@/views/auth/Signout'
import AboutDeveloper from '@/views/developer/About'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'home', component: Home, meta: { requiresAuth: true } },
    { path: '/welcome/:id', name: 'welcome custom', component: WelcomeCustom },
    // { path: '/account', name: 'My Account', component: Account, meta: { requiresAuth: true } },
    { path: '/login', name: 'Login', component: Login },
    { path: '/register', name: 'Register', component: Register },
    { path: '/registration/complete', name: 'Register Confirmation', component: RegistrationComplete },
    { path: '/forgot-password', name: 'Forgot Password', component: ForgotPassword },
    { path: '/reset-password/:hash', name: 'New Password', component: NewPassword },
    { path: '/email-confirmation/:hash', name: 'Confirm Email', component: ConfirmEmail },
    { path: '/invitation/:hash', name: 'Accept Invitation', component: AcceptInvitation },
    { path: '/signout', name: 'Sign out', component: Signout },
    { path: '/about-developer/:id', name: 'About Developer', component: AboutDeveloper }
    // { path: '/settings/', name: 'settings', component: Settings },
    // { path: '/account/', name: 'account', component: Account },
    // { path: '/signout/', name: 'signout', component: Signout },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
    // }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null) {
      next({
        path: `/welcome/${localStorage.getItem('token')}`,
        params: { nextUrl: to.fullPath } // FIXME: this line has no effect for some reason
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
